import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';


@Component({
  selector: 'app-calculadora',
  templateUrl: './calculadora.component.html',
  styleUrls: ['./calculadora.component.css']
})


export class CalculadoraComponent {



  razaoSocial: string = '';
  funcionario: string = '';


  salarioBase_50: number = 0;
  horaMes_50: number = 0;
  hora_50: number = 0;
  minuto_50: number = 0;

  salarioBase_80: number = 0;
  horaMes_80: number = 0;
  hora_80: number = 0;
  minuto_80: number = 0;

  salarioBase_100: number = 0;
  horaMes_100: number = 0;
  hora_100: number = 0;
  minuto_100: number = 0;

  salarioBase_120: number = 0;
  horaMes_120: number = 0;
  hora_120: number = 0;
  minuto_120: number = 0;


  salarioBase_Feriado: number = 0;
  horaMes_Feriado: number = 0;
  hora_Feriado: number = 0;
  minuto_Feriado: number = 0;

  diasUteis: number = 0;
  diasRepouso: number = 0;

  salarioBaseSalario: number = 0;
  diasSalario: number = 0;

  valorTotalHoras_50: number = 0;
  valorTotalHoras_80: number = 0;
  valorTotalHoras_100: number = 0;
  valorTotalHoras_120: number = 0;
  valorTotalHoras_Feriado: number = 0;
  valorTotalSalarioDiario: number = 0;

  valorHorasConvertidas_50: number = 0;
  valorHorasConvertidas_80: number = 0;
  valorHorasConvertidas_100: number = 0;
  valorHorasConvertidas_120: number = 0;
  valorHorasConvertidas_Feriado: number = 0;

  valorTotalHorasExtras: number = 0;
  valorTotalFeriado: number = 0;
  valorTotalDsr: number = 0;
  valorTotalPagamento: number = 0;
  modalRef: BsModalRef;

  public dateObj = new Date();
  public month = this.dateObj.getUTCMonth() + 1; //months from 1-12
  public day = this.dateObj.getUTCDate();
  public year = this.dateObj.getUTCFullYear();
  public mesConvertido = this.month.toString().length == 1 ? '0' + this.month.toString() : this.month.toString();
  
  public periodo = this.mesConvertido + '/' + this.year;


  constructor(private modalService: BsModalService, private router: Router) { }

  validarRecibo(): void {
    if (this.razaoSocial == '' && this.funcionario == '') {
      alert('Favor informar razão social e nome do funcionário nos campos abaixo:');
    } else {
      this.router.navigate(['recibo', this.razaoSocial, this.funcionario, this.hora_50, this.minuto_50, this.valorTotalHoras_50.toFixed(2), this.hora_80, this.minuto_80, this.valorTotalHoras_80.toFixed(2), this.hora_100, this.minuto_100, this.valorTotalHoras_100.toFixed(2), this.hora_120, this.minuto_120, this.valorTotalHoras_120.toFixed(2), this.hora_Feriado, this.minuto_Feriado, this.valorTotalFeriado.toFixed(2), this.valorTotalDsr.toFixed(2), this.valorTotalPagamento.toFixed(2), this.diasSalario, this.valorTotalSalarioDiario.toFixed(2)])
      this.razaoSocial = '';
      this.funcionario = '';
    }
  }

  GerarPdf(): void {
    if (this.razaoSocial == '' && this.funcionario == '') {
      alert('Favor informar razão social e nome do funcionário nos campos abaixo:');
    } else {
      let documento = new jsPDF('p', 'pt', 'a4', true);      
      var divNova = document.createElement("focus").innerHTML = `<div class="container">
                            <div class="row">
                              <div class="col-sm">
                              <BR>
                              <TABLE FRAME=VOID CELLSPACING=0 COLS=8 RULES=NONE BORDER=0>
                              <TBODY>
                                  <TR>
                                      <TD COLSPAN=7 ALIGN=CENTER>Recibo</TD>
                                  </TR>
                                  <TR>
                                      <TD STYLE="font-size: 15px;" ALIGN=LEFT>Empresa:</TD>
                                      <TD STYLE="font-size: 15px;" COLSPAN=2 ALIGN=LEFT>${this.razaoSocial}</TD>
                                      <TD STYLE="font-size: 15px;" ALIGN=RIGHT>Período:</TD>
                                      <TD STYLE="font-size: 15px;" ALIGN=RIGHT>${this.periodo}</TD>
                                  </TR>
                                  <TR>
                                      <TD STYLE="font-size: 15px;" ALIGN=LEFT>Funcionário:</TD>
                                      <TD STYLE="font-size: 15px;" COLSPAN=2 ALIGN=LEFT>${this.funcionario}</TD>
                                      <TD STYLE="font-size: 15px;" COLSPAN=2 ALIGN=RIGHT>Folha de Pagamento</TD>
                                  </TR>
                                  <TR>
                                      <TD STYLE="border-bottom: 1px solid #000; border-top: 1px solid #000000; font-size: 13px; border-left: 1px solid #000000;" ALIGN=CENTER>Codigo</TD>
                                      <TD STYLE="border-bottom: 1px solid #000; border-top: 1px solid #000000; font-size: 13px; border-left: 1px solid #000000;" ALIGN=CENTER>Descrição</TD>
                                      <TD STYLE="border-bottom: 1px solid #000; border-top: 1px solid #000000; font-size: 13px; border-left: 1px solid #000000;" ALIGN=CENTER>Referência</TD>
                                      <TD STYLE="border-bottom: 1px solid #000; border-top: 1px solid #000000; font-size: 13px; border-left: 1px solid #000000;" ALIGN=CENTER>Vencimentos</TD>
                                      <TD STYLE="border-bottom: 1px solid #000; border-top: 1px solid #000000; font-size: 13px; border-left: 1px solid #000000; border-right: 1px solid #000000;" ALIGN=CENTER>Descontos</TD>
                                  </TR>
                                  <TR>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=LEFT></TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 13px;" ALIGN=LEFT>&nbsp;&nbsp;Hora Extra de 50%</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.hora_50.toString().length == 1 ? '0' + this.hora_50 : this.hora_50}:${this.minuto_50.toString().length == 1 ? '0' + this.minuto_50 : this.minuto_50}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.valorTotalHoras_50.toFixed(2)}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px; border-right: 1px solid #000000" ALIGN=LEFT></TD>
                                  </TR>
                                  <TR>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=LEFT></TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 13px;" ALIGN=LEFT>&nbsp;&nbsp;Hora Extra de 80%</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.hora_80.toString().length == 1 ? '0' + this.hora_80 : this.hora_80}:${this.minuto_80.toString().length == 1 ? '0' + this.minuto_80 : this.minuto_80}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.valorTotalHoras_80.toFixed(2)}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px; border-right: 1px solid #000000" ALIGN=LEFT></TD>
                                  </TR>
                                  <TR>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=LEFT></TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 13px;" ALIGN=LEFT>&nbsp;&nbsp;Hora Extra de 100%</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.hora_100.toString().length == 1 ? '0' + this.hora_100 : this.hora_100}:${this.minuto_100.toString().length == 1 ? '0' + this.minuto_100 : this.minuto_100}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.valorTotalHoras_100.toFixed(2)}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px; border-right: 1px solid #000000" ALIGN=LEFT></TD>
                                  </TR>
                                  <TR>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=LEFT></TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 13px;" ALIGN=LEFT>&nbsp;&nbsp;Hora Extra de 120%</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.hora_120.toString().length == 1 ? '0' + this.hora_120 : this.hora_120}:${this.minuto_120.toString().length == 1 ? '0' + this.minuto_120 : this.minuto_120}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.valorTotalHoras_120.toFixed(2)}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px; border-right: 1px solid #000000" ALIGN=LEFT></TD>
                                  </TR>
                                  <TR>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=LEFT></TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 13px;" ALIGN=LEFT>&nbsp;&nbsp;Feriado</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.hora_Feriado.toString().length == 1 ? '0' + this.hora_Feriado : this.hora_Feriado}:${this.minuto_Feriado.toString().length == 1 ? '0' + this.minuto_Feriado : this.minuto_Feriado}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.valorTotalFeriado.toFixed(2)}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px; border-right: 1px solid #000000" ALIGN=LEFT></TD>
                                  </TR>
                                  <TR>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=LEFT></TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 13px;" ALIGN=LEFT>&nbsp;&nbsp;Salário</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.diasSalario}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.valorTotalSalarioDiario.toFixed(2)}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px; border-right: 1px solid #000000" ALIGN=LEFT></TD>
                                  </TR>
                                  <TR>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=LEFT></TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 13px;" ALIGN=LEFT>&nbsp;&nbsp;Dsr</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=LEFT><BR></TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px;" ALIGN=CENTER>&nbsp;&nbsp;${this.valorTotalDsr.toFixed(2)}</TD>
                                      <TD STYLE="border-left: 1px solid #000000; font-size: 15px; border-right: 1px solid #000000" ALIGN=LEFT></TD>
                                  </TR>
                                  <TR>
                                      <TD STYLE="border-bottom: 1px solid #000000; border-left: 1px solid #000000;" ALIGN=LEFT><BR></TD>
                                      <TD STYLE="border-bottom: 1px solid #000000; border-left: 1px solid #000000;" ALIGN=LEFT><BR></TD>
                                      <TD STYLE="border-bottom: 1px solid #000000; border-left: 1px solid #000000;" ALIGN=LEFT><BR></TD>
                                      <TD STYLE="border-bottom: 1px solid #000000; border-left: 1px solid #000000;" ALIGN=LEFT><BR></TD>
                                      <TD STYLE="border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000;" ALIGN=LEFT><BR></TD>
                                  </TR>
                                  <TR>
                                      <TD HEIGHT=16 ALIGN=LEFT><BR></TD>
                                      <TD ALIGN=LEFT><BR></TD>
                                      <TD ALIGN=LEFT><BR></TD>
                                      <TD STYLE="border-bottom: 1px solid #000000; font-size: 13px; border-left: 1px solid #000000;" ALIGN=LEFT>Total:</TD>
                                      <TD STYLE="border-bottom: 1px solid #000000; font-size: 13px; text-align: right; border-right: 1px solid #000000; padding-right: 10px;" ALIGN=LEFT>R$ ${this.valorTotalPagamento.toFixed(2)}</TD>
                                      <TD ALIGN=LEFT><BR></TD>
                                  </TR>
                                  <TR STYLE="color: white; user-select: none !important;">
                                      <TD ALIGN=LEFT><BR></TD>
                                      <TD ALIGN=LEFT>===============</TD>
                                      <TD ALIGN=LEFT>========</TD>
                                      <TD ALIGN=LEFT>========</TD>
                                      <TD ALIGN=LEFT>========</TD>
                                  </TR>
                    <TR>
                        <TD COLSPAN=3 ALIGN=LEFT>______________________________</TD>
                        <TD HEIGHT=16 ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                    </TR>
                    <TR>
                        <TD COLSPAN=2 ALIGN=LEFT>${this.funcionario}</TD>
                        <TD HEIGHT=16 ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                    </TR>
                    <TR>
                        <TD COLSPAN=6 ALIGN=LEFT><FONT COLOR="#000000">*Declaro ter recebido a importância líquida discriminada neste recibo.</FONT></TD>
                        <TD HEIGHT=16 ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                    </TR>
                    <TR>
                        <TD COLSPAN=2 ALIGN=LEFT>Data: ___/___/______</TD>
                        <TD HEIGHT=16 ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                    </TR>
                    <TR>
                        <TD HEIGHT=16 ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                        <TD ALIGN=LEFT><BR></TD>
                    </TR>
                    </TBODY></TABLE></div></div></div>`
      documento.html(divNova, { x: 25, y: 5}).then(() => documento.output("dataurlnewwindow"));
      this.router.navigate(['recibo', this.razaoSocial, this.funcionario, this.hora_50, this.minuto_50, this.valorTotalHoras_50.toFixed(2), this.hora_80, this.minuto_80, this.valorTotalHoras_80.toFixed(2), this.hora_100, this.minuto_100, this.valorTotalHoras_100.toFixed(2), this.hora_120, this.minuto_120, this.valorTotalHoras_120.toFixed(2), this.hora_Feriado, this.minuto_Feriado, this.valorTotalFeriado.toFixed(2), this.valorTotalDsr.toFixed(2), this.valorTotalPagamento.toFixed(2), this.diasSalario, this.valorTotalSalarioDiario.toFixed(2)])
      this.razaoSocial = '';
      this.funcionario = '';      
    }
  }

  Calcular(): string {

    if (this.minuto_50 > 59 || this.minuto_80 > 59 || this.minuto_100 > 59 || this.minuto_120 > 59 || this.minuto_Feriado > 59) {
      alert('Campo de minuto inválido');
      return 'erro';
    }

    if (this.salarioBase_50 < 0 || this.salarioBase_80 < 0 || this.salarioBase_100 < 0 || this.salarioBase_120 < 0 || this.salarioBase_Feriado < 0) {
      alert('Campo de salário inválido');
      return 'erro';
    }


    let totalHorasConvertidas_50: number = this.hora_50 + (this.minuto_50 / 60);
    let totalHorasConvertidas_80: number = this.hora_80 + (this.minuto_80 / 60);
    let totalHorasConvertidas_100: number = this.hora_100 + (this.minuto_100 / 60);
    let totalHorasConvertidas_120: number = this.hora_120 + (this.minuto_120 / 60);
    let totalHorasConvertidas_Feriado: number = this.hora_Feriado + (this.minuto_Feriado / 60);
    let totalSalario: number = (this.salarioBaseSalario / 30) * this.diasSalario;

    let valorHorasExtras_50: number = 0 || (((this.salarioBase_50 / this.horaMes_50) * (1.5)) * totalHorasConvertidas_50);
    let valorHorasExtras_80: number = 0 || (((this.salarioBase_80 / this.horaMes_80) * (1.8)) * totalHorasConvertidas_80);
    let valorHorasExtras_100: number = 0 || (((this.salarioBase_100 / this.horaMes_100) * (2)) * totalHorasConvertidas_100);
    let valorHorasExtras_120: number = 0 || (((this.salarioBase_120 / this.horaMes_120) * (2.2)) * totalHorasConvertidas_120);
    let valorHorasExtras_Feriado: number = 0 || (((this.salarioBase_Feriado / this.horaMes_Feriado) * (2)) * totalHorasConvertidas_Feriado);

    this.valorHorasConvertidas_50 = parseFloat(totalHorasConvertidas_50.toFixed(2));
    this.valorHorasConvertidas_80 = parseFloat(totalHorasConvertidas_80.toFixed(2));
    this.valorHorasConvertidas_100 = parseFloat(totalHorasConvertidas_100.toFixed(2));
    this.valorHorasConvertidas_120 = parseFloat(totalHorasConvertidas_120.toFixed(2));
    this.valorHorasConvertidas_Feriado = parseFloat(totalHorasConvertidas_Feriado.toFixed(2));

    if (valorHorasExtras_50.toFixed(2) == 'NaN') valorHorasExtras_50 = 0;
    if (valorHorasExtras_80.toFixed(2) == 'NaN') valorHorasExtras_80 = 0;
    if (valorHorasExtras_100.toFixed(2) == 'NaN') valorHorasExtras_100 = 0;
    if (valorHorasExtras_120.toFixed(2) == 'NaN') valorHorasExtras_120 = 0;
    if (valorHorasExtras_Feriado.toFixed(2) == 'NaN') valorHorasExtras_Feriado = 0;


    this.valorTotalHoras_50 = valorHorasExtras_50;
    this.valorTotalHoras_80 = valorHorasExtras_80;
    this.valorTotalHoras_100 = valorHorasExtras_100;
    this.valorTotalHoras_120 = valorHorasExtras_120;
    this.valorTotalHoras_Feriado = valorHorasExtras_Feriado;

    this.valorTotalHorasExtras = parseFloat((valorHorasExtras_50 + valorHorasExtras_80 + valorHorasExtras_100 + valorHorasExtras_120).toFixed(2));
    this.valorTotalFeriado = valorHorasExtras_Feriado;
    this.valorTotalDsr = parseFloat((((this.valorTotalHorasExtras + this.valorTotalFeriado) / this.diasUteis) * this.diasRepouso).toFixed(2));
    this.valorTotalSalarioDiario = parseFloat(totalSalario.toFixed(2));

    if (isNaN(this.valorTotalHorasExtras)) this.valorTotalHorasExtras = 0;
    if (isNaN(this.valorTotalFeriado)) this.valorTotalFeriado = 0;
    if (isNaN(this.valorTotalDsr)) this.valorTotalDsr = 0;

    this.valorTotalPagamento = this.valorTotalHorasExtras + this.valorTotalDsr + this.valorTotalFeriado + this.valorTotalSalarioDiario;
    return 'ok'
  };

  Reiniciar(): void {
    this.razaoSocial = '';
    this.funcionario = '';
    this.salarioBase_50 = 0;
    this.horaMes_50 = 0;
    this.hora_50 = 0;
    this.minuto_50 = 0;
    this.salarioBase_80 = 0;
    this.horaMes_80 = 0;
    this.hora_80 = 0;
    this.minuto_80 = 0;
    this.salarioBase_100 = 0;
    this.horaMes_100 = 0;
    this.hora_100 = 0;
    this.minuto_100 = 0;
    this.salarioBase_120 = 0;
    this.horaMes_120 = 0;
    this.hora_120 = 0;
    this.minuto_120 = 0;
    this.salarioBase_Feriado = 0;
    this.horaMes_Feriado = 0;
    this.hora_Feriado = 0;
    this.minuto_Feriado = 0;
    this.diasUteis = 0;
    this.diasRepouso = 0;
    this.salarioBaseSalario = 0;
    this.diasSalario = 0;
    this.valorTotalHoras_50 = 0;
    this.valorTotalHoras_80 = 0;
    this.valorTotalHoras_100 = 0;
    this.valorTotalHoras_120 = 0;
    this.valorTotalHoras_Feriado = 0;
    this.valorTotalSalarioDiario = 0;
    this.valorHorasConvertidas_50 = 0;
    this.valorHorasConvertidas_80 = 0;
    this.valorHorasConvertidas_100 = 0;
    this.valorHorasConvertidas_120 = 0;
    this.valorHorasConvertidas_Feriado = 0;
    this.valorTotalHorasExtras = 0;
    this.valorTotalFeriado = 0;
    this.valorTotalDsr = 0;
    this.valorTotalPagamento = 0;
  };

}
